import program from './program/index';

export default {
  program,
};
